import styled from 'styled-components'

import { SlideOut as SlideOutBase } from '@icontainers/design-system/dist/organisms/SlideOut'

export const SlideOut = styled(SlideOutBase)`
    .member-body {
        padding: 0;
    }

    .member-footer {
        background-color: ${(props) => props.theme.color.white};
        padding: 0;
    }
`

export const TopWrapper = styled.div`
    border-bottom: 1px solid ${(props) => props.theme.color.black};
    padding: 15px 15px 0;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 50px 50px 0;
    }
`

export const ImageWrapper = styled.div`
    max-width: 350px;
    min-height: 240px;
`

export const LinkedInWrapper = styled.a`
    background-color: ${(props) => props.theme.color.p500};
    border-radius: 4px;
    height: 57px;
    width: 57px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`

export const BioWrapper = styled.div`
    padding: 30px 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 20px 50px;
    }
`

export const Name = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.p500};
    margin-bottom: 5px;
`

export const Post = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g600};
    font-style: italic;
    margin-bottom: 20px;
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g600};
    text-align: justify;
`
